import * as z from "zod";

export const webEnvConfig = {
  clientPrefix: "VITE_",
  client: {
    VITE_AUTH_URL: z.url().default("http://localhost:4002"),
    VITE_ROOM_URL: z.url().default("http://localhost:4003"),
    VITE_API_URL: z.url().default("http://localhost:4000"),
    VITE_MARKETING_URL: z.string().min(1).default("/"),
  },
  shared: {
    DEV: z.boolean(),
  },
  emptyStringAsUndefined: true,
} as const;
